import React from 'react';
import { getCurrentDomain } from '../config/domains';

const Footer: React.FC = () => {
  const domain = getCurrentDomain();
  const currentYear = new Date().getFullYear();

  // Sister sites for cross-linking (only shown on intrnauts.net)
  const sisterSites = [
    { name: 'Intrnauts.ai', url: 'https://intrnauts.ai', tld: 'ai' },
    { name: 'Intrnauts.io', url: 'https://intrnauts.io', tld: 'io' },
    { name: 'Intrnauts.dev', url: 'https://intrnauts.dev', tld: 'dev' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Show sister site links only on intrnauts.net */}
          {domain.id === 'net' && (
            <div className="sister-sites">
              <span className="sister-sites-label">Visit our other sites: </span>
              {sisterSites.map((site, index) => (
                <React.Fragment key={site.tld}>
                  <a href={site.url} className="sister-site-link" target="_blank" rel="noopener noreferrer">
                    {site.name}
                  </a>
                  {index < sisterSites.length - 1 && <span className="site-separator"> | </span>}
                </React.Fragment>
              ))}
            </div>
          )}
          <p style={{ fontStyle: 'italic', marginBottom: '0.5rem' }}>
            An independent practice exploring software, systems, and applied intelligence.
          </p>
          <p>&copy; {currentYear} {domain.fullName}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
